import { GraphQLEnumType } from 'graphql'

export type SnapshotIntervalType = 'MINUTE' | 'HOUR' | 'DAY' | 'WEEK' | 'MONTH'

export const snapshotIntervalType = new GraphQLEnumType({
  name: 'SnapshotIntervalType',
  description:
    'Time intervals of the vulnerability snapshots that can be used as snapshots range',
  values: {
    MINUTE: {
      description: 'Minute interval'
    },
    HOUR: {
      description: 'Hour interval'
    },
    DAY: {
      description: 'Day interval'
    },
    WEEK: {
      description: 'Week interval'
    },
    MONTH: {
      description: 'Month interval'
    }
  }
})
